import React from 'react';
import ProfilePic from '../assets/john-doe-image.png';
import { AiFillStar } from "react-icons/ai";

const Testimonial = () => {
  return (
    <div className='work-section-wrapper' id='testimonials'>
      <div className='work-section-top'>
        <p className='primary-subheading'>Testimonial</p>
        <h1 className='primary-heading'>What Our Customers Are Saying</h1>
        <p className='primary-text'>Hear from food lovers who trust CraveOn for fresh meals, fast delivery, and a seamless ordering experience every time.</p>

      </div>
      <div className='testimonial-section-bottom'>
        <img src={ProfilePic} alt={ProfilePic} />
        <p>"CraveOn makes ordering food so easy. The delivery is always fast, the meals arrive hot and fresh, and the service never disappoints. It's my go-to app whenever I'm craving something delicious!"</p>
          <div className='testimonials-stars-container'>
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
          </div>
          <h2>John Doe</h2>
      </div>
    </div>
  )
}

export default Testimonial
